import * as React from "react";
import {IconProps, getIconSize} from "./IconInterface"

export const IconMoveX = ({
  className,
  size = "md"
}: IconProps) => {
  const sizeOption = getIconSize(size)
  return (
    <svg width={24} height={24} className={`${className} ${sizeOption}`} >
        <g
        stroke="#1C1F2B"
        strokeWidth={2}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        >
        <path
            d="M3.515 14.828.686 12m0 0 2.829-2.828M.686 12h7.071m15.557 0h-7.071m7.07 0-2.828-2.828M23.314 12l-2.829 2.828"
            strokeLinejoin="round"
        />
        <path d="M12 2v19" />
        </g>
    </svg>
  )
}